"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpBox = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const DEFAULT_FLEX_DIRECTION = 'row';
const DEFAULT_CONTENT_JUSTIFICATION = 'start';
const DEFAULT_ALIGN_ITEMS = 'stretch';
const DEFAULT_ALIGN_CONTENT = 'start';
const DEFAULT_WRAP_ITEMS = false;
let ItpBox = class ItpBox extends vue_1.default {
    flex;
    direction;
    inline;
    reverseDirection;
    responsive;
    justifyContent;
    alignItems;
    alignContent;
    wrapItems;
    reverseWrapItems;
    spacing;
    data() {
        return { className: this.getClassName() };
    }
    getClassName() {
        return [
            'itp-box',
            this.getFlex(),
            this.getDirection(),
            this.getContentJustification(),
            this.getContentAlignment(),
            this.getItemsAlignment(),
            this.getItemsWrapping(),
            this.getSpacing()
        ].filter((p) => !!p);
    }
    getFlex() {
        if (!this.flex) {
            return;
        }
        return [
            'd',
            this.responsive ? 'responsive' : null,
            this.inline ? 'inline' : null,
            'flex'
        ]
            .filter((p) => !!p)
            .join('-');
    }
    getDirection() {
        if (!this.flex ||
            (!this.responsive &&
                !this.reverseDirection &&
                this.direction === DEFAULT_FLEX_DIRECTION)) {
            return;
        }
        return [
            'flex',
            this.responsive,
            this.direction,
            this.reverseDirection ? 'reverse' : null,
        ]
            .filter((p) => !!p)
            .join('-');
    }
    getContentJustification() {
        if (!this.flex ||
            (!this.responsive &&
                this.justifyContent === DEFAULT_CONTENT_JUSTIFICATION)) {
            return;
        }
        return ['justify-content', this.responsive, this.justifyContent]
            .filter((p) => !!p)
            .join('-');
    }
    getItemsAlignment() {
        if (!this.flex ||
            (!this.responsive && this.alignItems === DEFAULT_ALIGN_ITEMS)) {
            return;
        }
        return ['align-items', this.responsive, this.alignItems]
            .filter((p) => !!p)
            .join('-');
    }
    getContentAlignment() {
        if (!this.flex ||
            (!this.responsive && this.alignContent === DEFAULT_ALIGN_CONTENT)) {
            return;
        }
        return ['align-content', this.responsive, this.alignContent]
            .filter((p) => !!p)
            .join('-');
    }
    getItemsWrapping() {
        if (!this.flex ||
            (!this.responsive &&
                !this.reverseWrapItems &&
                this.wrapItems === DEFAULT_WRAP_ITEMS)) {
            return;
        }
        return [
            'flex',
            this.responsive,
            this.wrapItems ? 'wrap' : 'nowrap',
            this.reverseWrapItems ? 'reverse' : null,
        ]
            .filter((p) => !!p)
            .join('-');
    }
    getSpacing() {
        if (this.spacing) {
            return this.spacing;
        }
    }
};
exports.ItpBox = ItpBox;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpBox.prototype, "flex", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: DEFAULT_FLEX_DIRECTION }),
    __metadata("design:type", String)
], ItpBox.prototype, "direction", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpBox.prototype, "inline", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpBox.prototype, "reverseDirection", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpBox.prototype, "responsive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: DEFAULT_CONTENT_JUSTIFICATION }),
    __metadata("design:type", String)
], ItpBox.prototype, "justifyContent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: DEFAULT_ALIGN_ITEMS }),
    __metadata("design:type", String)
], ItpBox.prototype, "alignItems", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: DEFAULT_ALIGN_CONTENT }),
    __metadata("design:type", String)
], ItpBox.prototype, "alignContent", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: DEFAULT_WRAP_ITEMS, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpBox.prototype, "wrapItems", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpBox.prototype, "reverseWrapItems", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], ItpBox.prototype, "spacing", void 0);
exports.ItpBox = ItpBox = __decorate([
    (0, vue_property_decorator_1.Component)({ template: '<div :class="className" v-on="$listeners"><slot></slot></div>' })
], ItpBox);
//# sourceMappingURL=box.js.map